<template>
  <v-container fluid grid-list-lg>
    <v-layout>
      <v-flex>
        <h1 class="display-3">{{ titulo }} Obra {{ (oper === 'edit') ? d.id : '' }}</h1>
        <v-layout align-center>
          <v-flex>
            <router-link exact :to="'/presupuesto/' + presup" class="display-1">Presupuesto Nº {{
                presup
              }}
            </router-link>
          </v-flex>
          <v-flex xs2>
            <revisiones @change="revisionMostrar()" v-model="revision" :id.sync="d.id"></revisiones>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex>
        <empresa-select v-model="d.empresa_id" validate="required"></empresa-select>
      </v-flex>
      <v-flex>
        <ubicacion-select v-model="d.ubicacion" validate="required"></ubicacion-select>
      </v-flex>
      <v-flex>
        <v-checkbox label="¿Para stock?" v-model="d.stock"></v-checkbox>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex>
        <v-card>
          <v-card-text>
            <v-layout row wrap>
              <v-flex>
                <v-text-field v-model="d.obr_desc"
                              label="Descripción"
                              :error-messages="errores.collect('obr_desc')"
                              v-validate="'required'"
                              data-vv-name="obr_desc"
                              type="text"
                              required
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field v-model="d.obr_presup"
                              label="Nº Presupuesto OPI"
                              :error-messages="errores.collect('obr_presup')"
                              v-validate="'required'"
                              data-vv-name="obr_presup"
                              type="number"
                              required
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field v-model="d.obr_revision"
                              label="Nº de revisión"
                              :error-messages="errores.collect('obr_revision')"
                              v-validate="'required'"
                              data-vv-name="obr_revision"
                              type="number"
                              required
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex>
                <v-text-field
                    v-model="d.pu"
                    label="Precio Unitario"
                    :prefix="moneda.signo"
                    :error-messages="errores.collect('pu')"
                    data-vv-name="pu"
                    type="text"
                    v-validate="'required'"
                    required></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field
                    label="Descuento comercial"
                    v-model="d.descuento_com"
                    prefix="%"
                    :error-messages="errores.collect('descuento_com')"
                    v-validate="{descuento_com:[d.item_id,id]}"
                    data-vv-name="descuento_com"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field
                    label="Descuento estratégico"
                    v-model="d.descuento_est"
                    prefix="%"
                    :error-messages="errores.collect('descuento_est')"
                    v-validate="{descuento_est:[d.item_id,id]}"
                    data-vv-name="descuento_est"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field
                    v-model="subtotal"
                    readonly
                    label="Subtotal"
                    :prefix="moneda.signo"
                    :error-messages="errores.collect('subtotal')"
                    v-validate="'required'"
                    data-vv-name="subtotal"
                    required></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex>
                <v-textarea label="Observaciones"
                            v-model="d.obs"
                            multi-line
                            counter="100"
                            :error-messages="errores.collect('obs')"
                            v-validate="'max:100'"
                            data-vv-name="obs"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" dark :to="'/presupuesto/' + presup">CANCELAR</v-btn>
            <v-btn color="green" dark @click.native="guardar" :loading="loading">Guardar</v-btn>
          </v-card-actions>
        </v-card>
        <v-spacer></v-spacer>
      </v-flex>
    </v-layout>
    <tabla-items tipo="obr" :presup="presup" :moneda="moneda.id" ref="tabla"></tabla-items>
  </v-container>
</template>

<script>
import {mapState, mapActions} from 'vuex'
import empresaSelect from '../../../components/EmpresaSelect';
import ubicacionSelect from '../../../components/UbicacionSelect';
import revisiones from '../../../components/Revisiones';
import itemSelect from '../../../components/ItemSelect';
import mixinPresupItem from '../../../mixins/presupuestoItems';
import mixinItems from '../../../mixins/items';
import mixinPresupuesto from '../../../mixins/presupuesto';
import mixinPrecio from '../../../mixins/precios';
import tablaItems from '../../../components/TablaItems';

function getInitialData() {
  return {
    obr_desc: '',
    obr_presup: '',
    obr_revision: '',
    item_tipo_id: '8',
    pu: 0,
    pu_orig: 0,
    subtotal: 0,
    obs: '',
    presupuesto_id: '',
    empresa_id: '',
    ubicacion: '',
    stock: false,
    descuento_com: '',
    descuento_est: '',
  }
}

export default {
  name: "add",
  $_veeValidate: {
    validator: 'new'
  },
  inject: ['$validator'],
  components: {tablaItems, itemSelect, empresaSelect, ubicacionSelect, revisiones},
  mixins: [mixinPresupItem, mixinItems, mixinPresupuesto, mixinPrecio],
  data() {
    return {
      revision: '',
      moneda: {signo: '', id: ''},
      loading: false,
      descuento_est_monto: 0,
      descuento_com_monto: 0,
      d: getInitialData(),
      editando: false
    }
  },
  computed: {
    ...mapState({
      presup: state => state.route.params.presup,
      oper: state => state.route.params.oper,
      id: state => state.route.params.id,
    }),
    titulo() {
      return (this.oper === 'add') ? 'Agregar' : 'Editar';
    },
    subtotal() {
      let subtot = this.d.pu;
      this.d.pu_orig = this.d.pu;
      if (this.d.descuento_com) {
        this.descuento_com_monto = (subtot / 100) * this.d.descuento_com;
        subtot = subtot - this.descuento_com_monto;
      }

      if (this.d.descuento_est) {
        this.descuento_est_monto = (subtot / 100) * this.d.descuento_est;
        subtot = subtot - this.descuento_est_monto;
      }

      this.d.subtotal = subtot;
      return new Intl.NumberFormat('es-AR').format(this.d.subtotal);
    },
    total() {
      if (!this.items) {
        return 0
      }
      return this.items.reduce((a, b) => {
        return a + b.subtotal
      }, 0)
    }
  },
  mounted() {
    this.traeMoneda();
    this.traeDatos();
    this.d.presupuesto_id = this.$store.state.route.params.presup
  },
  watch: {
    '$route': 'traeDatos',
  },
  methods: {
    ...mapActions('notif', ['msjShow']),
    limpiar() {
      this.d = getInitialData();
      this.d.presupuesto_id = this.$store.state.route.params.presup;
      this.item = {};
      this.$validator.reset();
    },
    traeDatos() {
      if (this.oper !== 'edit') {
        return false;
      }
      this.loading = true;
      this.presupuestoItemShow(this.id, r => {
        this.d = r;
        this.item = r.item;
        this.loading = false;
      }, err => {
        console.log(err);
        this.loading = false;
      })
    },
    traeMoneda() {
      this.presupuestoMoneda({presupuesto_id: this.presup}, r => {
        this.moneda = r;
      }, err => {
        console.log(err)
      })
    },
    guardar() {
      if (!this.d.presupuesto_id) {
        this.msjShow({txt: 'Falta numero de presupuesto', tipo: 'error'});
        return false;
      }
      if (this.editando) {
        this.msjShow({txt: 'Por favor confirme la modificación del preio unitario', tipo: 'error'});
        return false;
      }
      this.$validator.validateAll()
          .then(r => {
            if (r) {
              this.loading = true;
              if (this.oper === 'edit') {
                this.presupuestoItemUpdate(this.d, r => {
                  this.limpiar();
                  this.loading = false;
                  this.$refs.tabla.getItems();
                  this.msjShow(r);
                  this.$router.push('/presupuesto/' + this.presup);
                }, e => {
                  this.msjShow({txt: 'Error de validación', tipo: 'error', errores: (e.errors) ? e.errors : ''});
                  this.loading = false;
                })
              } else {
                this.presupuestoItemStore(this.d, r => {
                  this.limpiar();
                  this.loading = false;
                  this.$refs.tabla.getItems();
                  this.msjShow(r);
                }, e => {
                  this.msjShow({
                    txt: 'Error de validación',
                    tipo: 'error',
                    errores: (e.response.data.errors) ? e.response.data.errors : ''
                  });
                  this.loading = false;
                })
              }

            }
          })
    },
    revisionMostrar() {
      if (this.d.id) {
        this.loading = true;
        this.presupuestoItemRevisionShow({id: this.d.id, revision: this.revision}, r => {
          this.d = r;
          this.item = r.item;
          this.loading = false;
        })
      }
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/presup/item/obr.vue